import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d0b23954"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "fixed left-0 top-0 z-50 w-full h-full grid content-center bg-black/50 overflow-auto transition-opacity"
}
const _hoisted_2 = {
  class: "md:max-w-xl md:shadow-lg md:rounded-lg lg:w-3/5 w-4/5 min-h-fit min-w-[30%] max-h-[80vh] bg-white m-auto p-6 relative transition-all modal-container overflow-y-auto",
  id: "dialog"
}
const _hoisted_3 = { class: "border-modal-title pb-4" }
const _hoisted_4 = { class: "text-[16px] font-semibold" }
const _hoisted_5 = { class: "flex justify-end mt-3 py-6" }

import {
  ref,
  onMounted,
  onUnmounted,
  watch,
} from "vue";

// Declare props

export default /*#__PURE__*/_defineComponent({
  __name: 'NewModal',
  props: {
  title: {
    type: String,
    required: true,
  },
  visible: {
    type: Boolean,
    default: false,
    required: false,
  },
},
  emits: ["update:visible", "onClose"],
  setup(__props, { emit }) {

const props = __props;



// Declare emits


const openingModal = ref(false);

function clickOutside() {
  if (!openingModal.value) {
    close();
  }
}

function close() {
  emit("update:visible", false);
}

function onPressEsc(event: KeyboardEvent) {
  if (event.key == "Escape") {
    if (!openingModal.value) {
      close();
    }
  }
}

// Lifecycle hooks
onMounted(() => {
  addEventListener("keyup", onPressEsc);
});

onUnmounted(() => {
  removeEventListener("keyup", onPressEsc);
});

// Watch visible prop
watch(
  () => props.visible,
  (value) => {
    if (!value) {
      emit("onClose");
    } else {
      openingModal.value = true;
      setTimeout(() => {
        openingModal.value = false;
      }, 500);
    }
  }
);

return (_ctx: any,_cache: any) => {
  const _component_mdicon = _resolveComponent("mdicon")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        (__props.visible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_mdicon, {
                    class: "absolute right-4 top-6 text-gray-400 hover:text-gray-900 cursor-pointer",
                    name: "close",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (close()))
                  }),
                  _renderSlot(_ctx.$slots, "header", {}, () => [
                    _createElementVNode("h3", _hoisted_4, _toDisplayString(__props.title), 1)
                  ])
                ]),
                _createElementVNode("div", null, [
                  _renderSlot(_ctx.$slots, "default")
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _renderSlot(_ctx.$slots, "footer", {}, () => [
                    _createElementVNode("button", {
                      class: "w-full max-w-[200px] px-4 py-1.5 bg-[#008B4E] text-white font-semibold rounded-full shadow-md hover:scale-110 transition-all",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (close()))
                    }, " Entendido ")
                  ])
                ])
              ])), [
                [_directive_click_outside, clickOutside]
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}
}

})